import React from "react";
import cx from "classnames";
import ToolTipIcon from "@components/toolTipIcon";
import styled from "styled-components";
import { palette, size } from "styled-theme";
import { isNotNullOrEmpty } from "@src/utils/helpers/stringHelper";
import { useFormikContext } from "formik";

const _SelectBoxLabel = ({children, tooltip, optional, className, name}) => {
  const hasTooltip = !!tooltip;
  const {
      errors,
      touched,
    } = useFormikContext();

  return (
    <div className={className}>
      <label className={cx("selectBox-Label", { error: isNotNullOrEmpty(touched[name] ? errors[name] : "") })}>
        <span>{children}</span>
        {hasTooltip && <ToolTipIcon toolTipText={tooltip} />}
        {optional && <label className="selectBox-Label-Optional">optional</label>}
      </label>
    </div>
  );
};

export const SelectBoxLabel = styled(_SelectBoxLabel)`
  display: flex;
  width: fit-content;
  .selectBox-Label {
    display: inline-flex;
    padding-left: 3px;
    padding-bottom: 7px;
    color: ${palette("formInputElement", 0)};
    font-weight: 400;
    font-size: ${size("p0")};

    &.error {
      color: ${palette("error", 4)};
      font-weight: bold;
    }
  }
  .selectBox-Label-Optional {
    padding-left: 6px;
    font-size: ${size("p3")};
    color: ${palette("grayscale", 17)};
    font-weight: 400;
  }
`;